import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // Also handle any pending lazy-loaded content
    setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }), 10);
  }, [pathname]);

  return null;
};
